import { render, staticRenderFns } from "./SplitTwitter.vue?vue&type=template&id=7daf707f&scoped=true&"
import script from "./SplitTwitter.vue?vue&type=script&lang=ts&"
export * from "./SplitTwitter.vue?vue&type=script&lang=ts&"
import style0 from "./SplitTwitter.vue?vue&type=style&index=0&id=7daf707f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf707f",
  null
  
)

export default component.exports